import { readVenuePolicyRequest } from './venue-requests.js';
import { isOptionalTimeZone } from './date-time-metadata.js';
export class VenueWriteContractError extends Error {
  constructor(operation) {
    super(`Invalid venue ${operation} request.`);
    this.name = 'VenueWriteContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}

const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const id = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
const contact = value => value == null || isRecord(value) && typeof value.type === 'string' && ['User', 'Member'].includes(value.type.trim()) && id(value.refId || value._id || value.id);
const isText = value => typeof value === 'string' && value.trim().length > 0;
const types = new Set(['Residence', 'Online', 'CommunityVenue']);
const writeFields = new Set(['name', 'type', 'community', 'address', 'family', 'household', 'onlineLink', 'notes', 'availableForRequest', 'requiresBookingEnd', 'contact', 'policy', 'timeZone']);
const addressFields = ['formattedAddress', 'streetAddress', 'suburb', 'city', 'state', 'postalCode', 'countryCode', 'placeId'];
const isAddress = value => value === null || typeof value === 'string'
  || isRecord(value) && addressFields.every(field => value[field] === undefined || typeof value[field] === 'string');

export function readVenueWriteRequest(payload, operation = 'update') {
  if (!isRecord(payload)
    || payload.requiresBookingEnd !== undefined && typeof payload.requiresBookingEnd !== 'boolean'
    || !isOptionalTimeZone(payload.timeZone)
    || operation === 'create' && (!isText(payload.name) || !types.has(payload.type))
    || operation === 'update' && !Object.keys(payload).some(field => writeFields.has(field))
    || payload.name !== undefined && !isText(payload.name)
    || payload.type !== undefined && !types.has(payload.type)
    || payload.community !== undefined && !id(payload.community)
    || ['household', 'family', 'userId'].some(field => payload[field] != null && !id(payload[field]))
    || ['onlineLink', 'notes'].some(field => payload[field] != null && typeof payload[field] !== 'string')
    || typeof payload.notes === 'string' && payload.notes.trim().length > 1000
    || !contact(payload.contact)
    || operation === 'create' && payload.type === 'Online' && !isText(payload.onlineLink)
    || payload.address !== undefined && !isAddress(payload.address)
    || payload.availableForRequest !== undefined && typeof payload.availableForRequest !== 'boolean'
      && !['true', 'false'].includes(payload.availableForRequest)) {
    throw new VenueWriteContractError(operation);
  }
  if (payload.policy !== undefined) readVenuePolicyRequest(payload.policy);
  return payload;
}
